let Test = require('@/mixins/Forms/2019/NRCA_LTI_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.6.2.2)`,
                    questions: {
                        question_1: {
                            id: `a`,
                            question: `Occupant sensors have been located to minimize false signals. (NA7.6.2.2(a))`,
                            answer: false
                        },
                        question_2: {
                            id: `b`,
                            question: `Occupant sensors are located no closer than four (4) feet from any HVAC diffuser. (NA7.6.2.2(b))`,
                            answer: false
                        },
                        question_3: {
                            id: `c`,
                            question: `Passive infrared sensor pattern does not enter into adjacent zones. (NA7.6.2.2(c))`,
                            answer: false
                        },
                        question_4: {
                            id: `d`,
                            question: `Occupant sensors do not encounter any obstructions that could adversely affect desired performance. (NA7.6.2.2(d))`,
                            answer: false
                        },
                        question_5: {
                            id: `e`,
                            question: `Ultrasonic occupant sensors do not emit audible sound. (NA7.6.2.2(e), Section 110.9(b)6Bii)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: ` Functional Testing (NA7.6.2.5)`,
                    steps: {
                        step_1: {
                            name: `Step 1: Simulate an unoccupied condition. (NA7.6.2.3(a))`,
                            questions: {
                                question_1: {
                                    id: `a`,
                                    question: `Lights controlled by occupant sensing control turn off or partially off, if applicable, within a maximum of 20 minutes from start of an unoccupied condition. (NA7.6.2.3(a)1, Section 110.9(b)4A)<br>
                                                    In the partial off state, partial-OFF occupant sensors automatically reduce lighting power by at least 50% (Section 130.1(c)6A-C, Section 130.1(c)7A), <b>OR</b>:
                                                    <ul class="test-list-points">
                                                        <li>For metal halide or high pressure sodium lighting in warehouses, automatically reduce lighting power by at least 40% (EXCEPTION 2 to Section 130.1(c)6A).</li>
                                                        <li>In aisle ways and open areas in warehouses in which the installed lighting power is 80% or less of the value allowed under the Area Category Method, automatically reduce lighting power by at least 40% (EXCEPTION 1 to Section 130.1(c)6A).</li>
                                                        <li>In corridors and stairwells in which the installed lighting power is 80% or less of the value allowed under the Area Category Method, automatically reduce lighting power by at least 40% (EXCEPTION to Section 130.1(c)7A).</li>
                                                    </ul>
                                    Occupant sensing controls in parking garages, parking areas, and loading and unloading areas have at least one control step between 20 to 50% of design lighting power (Section 130.1(c)7B). <b>OR</b> Occupant sensing controls for metal halide luminaires with a lamp plus ballast mean system efficacy of 75 lumens per watt in parking garages, parking areas, and loading and unloading areas have at least one control step between 20 to 60% of design lighting power (EXCEPTION to Section 130.1(c)7B).`,
                                    answer: false
                                },
                                question_2: {
                                    id: `b`,
                                    question: `The occupant sensing control does not trigger a false "on" from movement in an area adjacent to the controlled space or from HVAC operation. (NA7.6.2.3(a)2)`,
                                    answer: false
                                },
                                question_3: {
                                    id: `c`,
                                    question: `Signal sensitivity is adequate to achieve desired control. (NA7.6.2.3(a)3) For library book stacks or warehouse aisles, activity beyond the stack or aisle shall not activate the lighting in the stack or aisle. (Section 130.1(c)6A, Section 130.1(c)6B)`,
                                    answer: false
                                }
                            }
                        },
                        step_2: {
                            name: `Step 2: Simulate an occupied condition. (NA7.6.2.3(b))`,
                            questions: {
                                question_1: {
                                    id: `a`,
                                    question: `Status indicator or annunciator operates correctly. (NA7.6.2.3(b)1, Section 110.9(b)4C)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `b`,
                                    question: `Immediately upon an occupied condition (NA7.6.2.3(b)2):<br>
                                     <ul class="test-list-points">
                                        <li>Lights controlled by an occupant sensor or a partial-OFF occupant sensor turn on; <b>OR</b></li>
                                        <li>A vacancy sensor indicates a space is "occupied" and lights may be turned on manually; <b>OR</b></li>
                                        <li>The first stage of a partial-ON occupant sensor automatically activates between 50 to 70% of the lighting. (Section 130.1(c)5A)</li>
                                    </ul>
                                    After the first stage occurs for partial-ON occupant sensors, manual switches allow an occupant to activate the alternate set of lights, activate 100% of the lighting power, and manually deactivate all of the lights.`,
                                    answer: false
                                },
                            }
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },
}


